module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"createdAt":"Date created","height":"Height","host":"Host","name":"Image name","remoteMediaUrl":"Remote URL","updatedAt":"Date updated","url":"URL","width":"Width"}}')
  delete Component.options._Ctor
}
